import React, { useEffect, useState } from "react";
import InsightTable from "../InsightTable";
import TopRightActionLinks from "../TopRightActionLinks";
import { transformResultsToTableData } from "../../../../services/commonService";
import { useParams } from "react-router-dom";

function PricingAndCostStrucures({ pricingAndCostStructures }) {
  const [tabData, setTabData] = useState([]);
  const { clientName, competitorName } = useParams();
  // Columns for GenericTable
  const tableColumns = [
    { key: "pricing_model", label: "Pricing Model" },
    {
      key: "subscription_offering",
      label: "Subscription Offering",
    },
    { key: "cost_efficiency", label: "Cost Efficiency" },
    { key: "margin_trend", label: "Margin Trend" },
  ];

  // const dummyData = [
  //   {
  //     competitor: clientName ?? "HB Fuller",
  //     pricing_model: "Fee-for-service, cost-plus, contract",
  //     subscription_offering: "Analytics & supply chain tools",
  //     cost_efficiency: "GMPD Plan: +$300M by 2026%",
  //     margin_trend: "Improving in specialty, pressure in pharma",
  //     pricing_model_positive_insight: "Fee-for-service, cost-plus, contract",
  //     pricing_model_negative_insight: "Fee-for-service, cost-plus, contract",
  //     pricing_model_recent_development: "Fee-for-service, cost-plus, contract",
  //     subscription_offering_positive_insight: "Analytics & supply chain tools",
  //     subscription_offering_negative_insight: "Analytics & supply chain tools",
  //     subscription_offering_recent_development:
  //       "Analytics & supply chain tools",
  //     cost_efficiency_positive_insight: "GMPD Plan: +$300M by 2026%",
  //     cost_efficiency_negative_insight: "GMPD Plan: +$300M by 2026%",
  //     cost_efficiency_recent_development: "GMPD Plan: +$300M by 2026%",
  //     margin_trend_positive_insight:
  //       "Improving in specialty, pressure in pharma",
  //     margin_trend_negative_insight:
  //       "Improving in specialty, pressure in pharma",
  //     margin_trend_recent_development:
  //       "Improving in specialty, pressure in pharma",
  //   },
  //   {
  //     competitor: competitorName ?? "Tailored Chemical Products",
  //     pricing_model: "Manufacturer-direct, volume-based",
  //     subscription_offering: "Clinical & supply chain solutions",
  //     cost_efficiency: "Vertical integration",
  //     margin_trend: "Higher than distribution peers",
  //     pricing_model_positive_insight: "Fee-for-service, cost-plus, contract",
  //     pricing_model_negative_insight: "Fee-for-service, cost-plus, contract",
  //     pricing_model_recent_development: "Fee-for-service, cost-plus, contract",
  //     subscription_offering_positive_insight: "Analytics & supply chain tools",
  //     subscription_offering_negative_insight: "Analytics & supply chain tools",
  //     subscription_offering_recent_development:
  //       "Analytics & supply chain tools",
  //     cost_efficiency_positive_insight: "GMPD Plan: +$300M by 2026%",
  //     cost_efficiency_negative_insight: "GMPD Plan: +$300M by 2026%",
  //     cost_efficiency_recent_development: "GMPD Plan: +$300M by 2026%",
  //     margin_trend_positive_insight:
  //       "Improving in specialty, pressure in pharma",
  //     margin_trend_negative_insight:
  //       "Improving in specialty, pressure in pharma",
  //     margin_trend_recent_development:
  //       "Improving in specialty, pressure in pharma",
  //   },
  //   {
  //     competitor: "AmerisourceBergen",
  //     pricing_model: "GPOs, performance-based",
  //     subscription_offering: "Oncology & analytics platforms",
  //     cost_efficiency: "Modernization programs",
  //     margin_trend: "Focus on specialty margin",
  //     pricing_model_positive_insight: "Fee-for-service, cost-plus, contract",
  //     pricing_model_negative_insight: "Fee-for-service, cost-plus, contract",
  //     pricing_model_recent_development: "Fee-for-service, cost-plus, contract",
  //     subscription_offering_positive_insight: "Analytics & supply chain tools",
  //     subscription_offering_negative_insight: "Analytics & supply chain tools",
  //     subscription_offering_recent_development:
  //       "Analytics & supply chain tools",
  //     cost_efficiency_positive_insight: "GMPD Plan: +$300M by 2026%",
  //     cost_efficiency_negative_insight: "GMPD Plan: +$300M by 2026%",
  //     cost_efficiency_recent_development: "GMPD Plan: +$300M by 2026%",
  //     margin_trend_positive_insight:
  //       "Improving in specialty, pressure in pharma",
  //     margin_trend_negative_insight:
  //       "Improving in specialty, pressure in pharma",
  //     margin_trend_recent_development:
  //       "Improving in specialty, pressure in pharma",
  //   },
  // ];

  useEffect(() => {
    const tableData = transformResultsToTableData(pricingAndCostStructures);
    setTabData(tableData);
  }, [pricingAndCostStructures]);

  const actions = [
    // { type: "chart", title: "Chart", onClick: () => {} },
    { type: "conversation", title: "Conversation", onClick: () => {} },
    { type: "mindMap", title: "Mind Map", onClick: () => {} },
    { type: "download", title: "Download", onClick: () => {} },
  ];

  return (
    <InsightTable
      title="Pricing & Cost Structures"
      data={tabData}
      metrics={tableColumns}
      rowIdentifier="competitor"
      actions={actions}
    />
  );
}

export default PricingAndCostStrucures;
